import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, CheckCircle2, AlertTriangle } from "lucide-react";
import { AdminGate } from "@/components/admin/AdminGate";

export const Route = createFileRoute("/admin/plano-revisao-pre-black")({
  head: () => ({
    meta: [
      { title: "Admin · Revisão pré-Black 2026" },
      { name: "description", content: "Revisão geral do site, banco, fluxos, velocidade e SEO antes da Black 2026." },
      { property: "og:title", content: "Admin · Revisão pré-Black 2026" },
      { property: "og:description", content: "O que está OK, o que foi corrigido e os pontos de atenção da operação." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <AdminGate route="/admin/plano-revisao-pre-black"><Revisao /></AdminGate>,
});

const blocos: { titulo: string; icon: typeof CheckCircle2; itens: string[] }[] = [
  {
    titulo: "OK",
    icon: CheckCircle2,
    itens: [
      "Banco de dados no ar, sem reinícios · disco 32% · memória 58% · conexões 8 de 60 · aguenta com folga o pico da Black",
      "Velocidade: buscas por e-mail a cada inscrição e verificação de aluno otimizadas para o pico · imagens leves (WebP)",
      "Captação: inscrições funcionando em todas as páginas · teste com 18 leads na Black aprovado (3 por vendedora)",
      "RD Station: 100% dos leads entregues, com tags black26-lista e black26-lista-entregas como QUENTE",
      "RD CRM e FEO CRM: rodízio das 6 vendedoras funcionando · etapas do RD CRM atualizadas sozinhas a cada hora no painel",
      "Eduzz: vendas chegando sozinhas para todos os produtos, incluindo a Black · botão Atualizar mostra a última venda recebida",
      "Regra de faturamento aplicada em todo o painel: Única sem juros e Assinatura com valor cheio do contrato (15x Orto, Dor, Esporte e Geronto · 12x Trauma, Prescrição, Passaporte e BLACK 2x1), histórico recalculado",
      "Checkouts: 12 links das vendedoras abrindo com o produto certo · oferta de alunos liberada só por CPF das 6 pós, com ALUNOFEO",
      "Painel: Dashboard BLACK 2026 com leads e vendas da ação · públicos de Meta e Google com as listas da Black e UTMs completas",
      "SEO e IAs: sem erros · /black-lista no Google, no mapa do site e no llms.txt · páginas de teste e ofertas fora do Google",
      "Segurança: dependências atualizadas e alertas revisados sem pendência",
    ],
  },
  {
    titulo: "Pontos de atenção",
    icon: AlertTriangle,
    itens: [
      "Grupos do WhatsApp comportam 1.024 pessoas cada · acompanhar a lotação durante a Black e trocar o link antes de lotar",
    ],
  },
];

function Revisao() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-10">
      <Link to="/admin/planos" className="inline-flex items-center gap-2 text-sm text-muted-foreground"><ArrowLeft className="h-4 w-4" /> Planos</Link>
      <h1 className="mt-4 text-3xl font-bold">Revisão pré-Black 2026</h1>
      <p className="mt-2 text-muted-foreground">Situação geral atualizada em 03/10/2026 · banco, captação, integrações, velocidade e SEO. Tarefas da ação ficam no plano da Black.</p>
      <div className="mt-8 space-y-6">
        {blocos.map((b) => (
          <section key={b.titulo} className="rounded-2xl border border-border bg-card p-6">
            <h2 className="flex items-center gap-2 text-xl font-semibold"><b.icon className="h-5 w-5 text-primary" /> {b.titulo}</h2>
            <ul className="mt-4 list-disc space-y-2 pl-5 text-sm">{b.itens.map((i) => <li key={i}>{i}</li>)}</ul>
          </section>
        ))}
      </div>
    </div>
  );
}
